
import { Injectable } from '@angular/core';
import { catchError, Observable, throwError } from 'rxjs';
import { FgiBackEndService } from '../../shared/fgi-back-end.service';
import { blockUi } from '@bndes/bndes-ux4/bndes-angular-utils';
import { ParametroConsultaImpedimento } from '../../model/parametro-consulta-impedimento.model';



@Injectable({
  providedIn: 'root'
})
export class ParametrizacaoService extends FgiBackEndService<ParametroConsultaImpedimento> {

  getNewEntity() {
    return new ParametroConsultaImpedimento();
  }

  protected getResourceURL(): string {
    return 'front/parametro/';
  }

    
    public buscar(params?: any, options?: any): Observable<any> {

        const url = `${this.BASE_URL}buscar`;

        return this.http.get<any>(url, {params: params}).pipe(
            catchError(this.handleError)
        );
    }

 public salvar(obj: ParametroConsultaImpedimento): Observable<ParametroConsultaImpedimento> {
    const options: any = blockUi();
    return this.http.post(`${this.BASE_URL}salvar`, obj, options).pipe
      (catchError((e) => this.handleError(e))) as Observable<any>;
  }

   public editar(obj: ParametroConsultaImpedimento): Observable<ParametroConsultaImpedimento> {
    const options: any = blockUi();
    return this.http.post(`${this.BASE_URL}editar`, obj, options).pipe
      (catchError((e) => this.handleError(e))) as Observable<any>;
  }

 


}
